import React, { useState, useEffect } from "react";
import firebase from "../firebase";
import "bootstrap/dist/css/bootstrap.min.css";
import "./home.css";

// importing components
import Blogpost from "../components/BlogPosts";
import Login from "./login";
import { Link } from "react-router-dom";

// functional component
const Home = (props) => {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    firebase
      .firestore()
      .collection("blog-post")
      .onSnapshot((Snapshot) => {
        setPosts(
          Snapshot.docs.map((post) => ({
            Id: post.id,
            Title: post.data().title,
            Author: post.data().author,
            Post: post.data().post,
          }))
        );
      });
  }, []);

  function signout() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        // setUser("");
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <div className="home">
      {!props.user ? (
        <Login />
      ) : (
        <div className="App">
          <nav className="navbar" id="navigation">
            <div className="container">
              <h3 className="Navbar-brand logo">BLOGO</h3>
              <h6 className="email">
                Welcome <span>{props.user}</span>
              </h6>
              {/* <div className="buttons">
                {/* <button type="button" className="btn btn-outline-dark">
                  Login
                </button>
                <button type="button" className="btn btn-outline-dark">
                  Register
                </button> 
              </div> */}
            </div>
          </nav>
          <div className="jumbotron" id="viewcase">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title heading">Blogging website</h5>
                <p className="card-text pera">
                  Click the Logout button to exit!
                </p>
                <button
                  type="button"
                  className="btn btn-info btn-lg"
                  onClick={signout}
                >
                  Logout
                </button>
                <Link
                  to={{
                    pathname: "/create",
                    state: props.user,
                  }}
                >
                  <button className="btn btn-info btn-lg">Create</button>
                </Link>
              </div>
            </div>
          </div>
          <h3 className="postsec-heading">Here are the posts</h3>
          <div id="posts">
            <div className="row">
              {posts.map((data) => (
                <Blogpost post={data} key={data.Id} />
              ))}
            </div>
          </div>
          <div id="foot">
            <h3>BLOGO</h3>
            <p>
              © All right reserved 2020 | <span>Rishabh Tyagi</span>
            </p>
            <div className="social">
              <p>Github 🗽Linkedin</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
